import { USER_INFO_UPDATE, USER_INFO_SET_ERRORS } from '../constants';
import { userInfoActions } from '../Reducers/UserInfo.reducer';
import { post } from '../Services/http';
import { translate } from '../Services/translation';
import Address from '../Types/Address';
import { UserInfoModel } from '../Types/UserInfoModel';

const BASE_ROUTE = '/api/userinfo';

interface ResponseError extends Error {
  response?: Response;
}

const handleErrorResponse = (error: ResponseError) => async (dispatch) => {
  if (error.response) {
    const res = error.response;
    const isJson = res.headers
      .get('content-type')
      ?.includes('application/json');
    const data = isJson ? await res.json() : { general: await res.text() };

    dispatch(userInfoActions.setErrors(data));
    dispatch(userInfoActions.setSuccessMessage(undefined));
  }
};

export const setUserInfoErrors = (errors: { [key: string]: string[] }) => ({
  type: USER_INFO_SET_ERRORS,
  payload: {
    errors,
  },
});

export const saveUserInfo = (userInfo: UserInfoModel): any => (dispatch) => {
  return post(`${BASE_ROUTE}/details`, userInfo)
    .then(() => {
      dispatch(userInfoActions.updateUserInfo(userInfo));
      dispatch(userInfoActions.resetErrors());
      dispatch(
        userInfoActions.setSuccessMessage(translate('general.changes-saved'))
      );
    })
    .catch((err) => dispatch(handleErrorResponse(err)));
};

export const saveUsername = (username: string): any => (dispatch) => {
  return post(`${BASE_ROUTE}/username`, { username })
    .then(() => {
      dispatch(userInfoActions.updateUsername(username));
      dispatch(userInfoActions.resetErrors());
      dispatch(
        userInfoActions.setSuccessMessage(translate('general.changes-saved'))
      );
    })
    .catch((err) => dispatch(handleErrorResponse(err)));
};

export const savePassword = (password: string): any => (dispatch) => {
  return post(`${BASE_ROUTE}/password`, { password })
    .then(() => {
      dispatch(userInfoActions.resetErrors());
      dispatch(
        userInfoActions.setSuccessMessage(translate('general.changes-saved'))
      );
    })
    .catch((err) => dispatch(handleErrorResponse(err)));
};

export const saveAddress = (address: Address): any => (dispatch) => {
  return post(`${BASE_ROUTE}/address`, address)
    .then(() => {
      dispatch(userInfoActions.updateAddress(address));
      dispatch(userInfoActions.resetErrors());
      dispatch(
        userInfoActions.setSuccessMessage(translate('general.changes-saved'))
      );
    })
    .catch((err) => dispatch(handleErrorResponse(err)));
};

export const setUserInfo = (userInfo: UserInfoModel) => ({
  type: USER_INFO_UPDATE,
  payload: userInfo,
});
